<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" sm="6">
                <h1 class="headline font-weight-light mb-3">
                    Health Check
                </h1>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
                <v-btn
                    fab
                    small
                    :color="chk_export_data == false ? 'green accent-3' : ''"
                    :disabled="chk_export_data == true"
                    class="mr-1 mt-2"
                    @click="export_data()"
                >
                    <v-icon
                        v-if="chk_export_data == false"
                        color="teal darken-4"
                        >mdi-file-excel</v-icon
                    >
                    <img
                        v-if="chk_export_data == true"
                        src="../../assets/all/Loading.gif"
                        style="width:6%; "
                    />
                </v-btn>
                <v-btn rounded color="primary" @click="open_dialog()">
                    <v-icon>mdi-plus</v-icon>
                    ทำแบบฟอร์มบันทึกผล
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-for="(row, index) in data_main" :key="index" class="mt-2">
            <v-col cols="12" class="col-thx11">
                {{ row.topic_name }}
            </v-col>
            <v-col cols="12" v-for="(r, i) in row.detail" :key="i">
                <div>
                    <span class="fttt01"> {{ r.detail_name }}</span>
                </div>
                <v-simple-table class="table-inv mt-1">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center" rowspan="2">#</th>
                                <th class="text-center" rowspan="2">
                                    ดำเนินการตรวจเช็ค
                                </th>
                                <th class="text-center" rowspan="2">
                                    วันที่เริ่มใช้งาน
                                </th>
                                <th class="text-center" colspan="3">
                                    มาตรฐานที่กำหนด
                                </th>
                                <th class="text-center" rowspan="2">
                                    ความถี่
                                </th>
                                <th class="text-center" rowspan="2"></th>
                            </tr>
                            <tr class="col-tr-1">
                                <th class="text-center col-thx00 col-thx01">
                                    Normal
                                </th>
                                <th class="text-center col-thx00 col-thx02">
                                    Warning
                                </th>
                                <th class="text-center col-thx00 col-thx03">
                                    Critical
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(rr, ii) in r.list" :key="ii">
                                <td class="text-center">{{ ii + 1 }}.</td>
                                <td>
                                    {{ rr.list_name }}
                                </td>
                                <td class="text-center">{{ rr.start_date }}</td>
                                <td>{{ rr.lvl_normal }}</td>
                                <td>{{ rr.lvl_warning }}</td>
                                <td>{{ rr.lvl_critical }}</td>
                                <td>{{ rr.frequency }}</td>
                                <td class="text-center">
                                    <v-btn
                                        fab
                                        x-small
                                        @click="view_detail(rr.list_id)"
                                    >
                                        <v-icon color="primary">
                                            mdi-magnify
                                        </v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="close_dialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content class="mt-5">
                                <v-list-item-title>
                                    <v-radio-group v-model="form.type" row>
                                        <v-radio
                                            label="Health"
                                            value="health"
                                        ></v-radio>
                                        <v-radio
                                            label="Config"
                                            value="config"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-title>
                                <div v-if="form.type != null">
                                    <v-row
                                        v-for="(rowx, indexx) in form.data"
                                        :key="indexx"
                                        class="mt-2"
                                    >
                                        <v-col cols="12" class="col-thx22 mb-5">
                                            <span class="ml-2">
                                                {{ rowx.topic_name }}
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            v-for="(rx, ix) in rowx.detail"
                                            :key="ix"
                                            class="mar-t-20"
                                        >
                                            <div
                                                v-for="(rxx, ixx) in rx.list"
                                                :key="ixx"
                                            >
                                                <v-text-field
                                                    :label="rxx.list_name"
                                                    v-model="rxx.detail"
                                                    class="ml-2"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                                <!-- -->
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="text-right">
                                            <v-btn
                                                color="success"
                                                @click="save()"
                                                rounded
                                            >
                                                <div class="ml-5 mr-5">
                                                    <v-icon small class="mr-1">
                                                        mdi-content-save
                                                    </v-icon>
                                                    Save
                                                </div>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_detail"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="close_dialog_detail()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content class="mt-5">
                                <v-tabs
                                    v-model="tab"
                                    background-color="blue accent-2"
                                    color="lime accent-2"
                                    class="elevation-2"
                                    dark
                                    :grow="true"
                                >
                                    <v-tabs-slider></v-tabs-slider>

                                    <v-tab
                                        v-for="i in tabs_name.length"
                                        :key="i"
                                        :href="`#tab-${i}`"
                                    >
                                        <!-- @click="change_tab(tabs_name[i - 1])" -->

                                        {{ tabs_name[i - 1] }}
                                    </v-tab>

                                    <v-tab-item
                                        v-for="i in tabs_name.length"
                                        :key="i"
                                        :value="'tab-' + i"
                                    >
                                        <div>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-simple-table
                                                        class="table-inv"
                                                    >
                                                        <template
                                                            v-slot:default
                                                        >
                                                            <thead>
                                                                <tr
                                                                    class="col-tr-1"
                                                                >
                                                                    <th
                                                                        class="text-center"
                                                                    >
                                                                        #
                                                                    </th>
                                                                    <th
                                                                        class="text-center"
                                                                    >
                                                                        Detail
                                                                    </th>
                                                                    <th
                                                                        class="text-center"
                                                                    >
                                                                        Created
                                                                        Name
                                                                    </th>
                                                                    <th
                                                                        class="text-center"
                                                                    >
                                                                        Created
                                                                        Date
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr
                                                                    v-for="(row,
                                                                    index) in data_detail[
                                                                        i == 1
                                                                            ? 'health'
                                                                            : 'config'
                                                                    ]"
                                                                    :key="index"
                                                                >
                                                                    <td
                                                                        class="text-center"
                                                                    >
                                                                        {{
                                                                            index +
                                                                                1
                                                                        }}.
                                                                    </td>
                                                                    <td>
                                                                        {{
                                                                            row.detail
                                                                        }}
                                                                    </td>
                                                                    <td
                                                                        class="text-center"
                                                                    >
                                                                        {{
                                                                            row.created_name
                                                                        }}
                                                                    </td>
                                                                    <td
                                                                        class="text-center"
                                                                    >
                                                                        {{
                                                                            row.created_date
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                                <br />
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </v-tab-item>
                                </v-tabs>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    methods: {
        async get_data() {
            this.dialog_loading = true
            await axios
                .get(url + "health-check/main-data")
                .then((response) => {
                    this.data_main = response.data.topic
                    this.form.data = response.data.topic
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        open_dialog() {
            this.dialog = true
        },
        close_dialog() {
            this.form = {
                data: [],
                type: null,
            }
            this.get_data()
            this.dialog = false
        },
        close_dialog_detail() {
            this.dialog_detail = false
        },
        // change_tab(change_tab) {
        //     this.get_data_issue(change_tab)
        // },
        async view_detail(list_id) {
            this.dialog_loading = true
            await axios
                .get(url + "health-check/view-record/" + list_id)
                .then((response) => {
                    this.data_detail = response.data
                    this.dialog_loading = false
                    this.dialog_detail = true
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async save() {
            this.dialog_loading = true
            console.log(this.form)
            await axios
                .post(url + "health-check/save-record", this.form, this.tk)
                .then((response) => {
                    this.close_dialog()
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async export_data() {
            this.chk_export_data = true
            await axios({
                url: url + "health-check/export",
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
    },
    data() {
        return {
            chk_export_data: false,
            tk: null,
            dialog: false,
            dialog_loading: false,
            dialog_detail: false,
            data_main: [],
            data_detail: [],
            modal: false,
            date: "",
            form: {
                data: [],
                type: null,
            },
            tab: false,
            active_tab: "รายงานบันทึกค่า Health Check",
            tabs_name: [
                "รายงานบันทึกค่า Health Check",
                "รายงานบันทึกค่า Config ในระบบ Monitoring Tools",
            ],
        }
    },
}
</script>
<style scoped>
.col-thx11 {
    background-color: #03426a;
    color: #ffff;
    font-weight: bold;
}
.col-thx22 {
    background-color: #d4d9de;
    color: rgb(55, 77, 134);
    font-weight: bold;
}
.col-thx01 {
    background-color: #44cf49;
}
.col-thx02 {
    background-color: #d6d600;
}
.col-thx03 {
    background-color: #de0d0d;
}
.col-thx00 > th {
    color: #fff !important;
}
.fttt01 {
    color: #1d3351;
    font-weight: bold;
    font-size: 16px;
}
.fttt11 {
    color: #2458a1;
    /* font-weight: bold; */
    font-size: 15px;
}
</style>
